import { createReducer, on } from '@ngrx/store';

import { ChangeState } from '../../interfaces/store.interface';
import { ChangeActions, SelectActionsUnion, StateActions } from '../actions';
import { MmbStage } from '../../enums';

export const initialState: ChangeState = {
  outbound: null,
  inbound: null,
  dates: [],
  list: null,
};

export const changeReducer = createReducer(
  initialState,
  on(ChangeActions.toggleOutbound, (state, { bound }) => {
    if (state.outbound) {
      return { ...state, outbound: null, dates: [null, state.dates[1]] };
    }
    return {
      ...state,
      outbound: { ...bound },
      dates: [bound.departure.dateTime, state.dates[1]],
    };
  }),
  on(ChangeActions.toggleInbound, (state, { bound }) => {
    if (state.inbound) {
      return { ...state, inbound: null, dates: [state.dates[0], null] };
    }
    return {
      ...state,
      inbound: { ...bound },
      dates: [state.dates[0], bound.departure.dateTime],
    };
  }),
  on(ChangeActions.setOutbound, (state, { bound }) => {
    return {
      ...state,
      outbound: { ...bound },
      dates: [bound.departure.dateTime, state.dates[1]],
    };
  }),
  on(ChangeActions.setInbound, (state, { bound }) => {
    return {
      ...state,
      inbound: { ...bound },
      dates: [state.dates[0], bound.departure.dateTime],
    };
  }),
  on(ChangeActions.setDates, (state, { dates }) => ({
    ...state,
    dates: dates ?? [],
  })),
  on(ChangeActions.setChangeList, (state, { list }) => ({
    ...state,
    list,
  })),
  on(StateActions.setStage, (state, { stage }) => {
    if (stage === MmbStage.VIEW) {
      return {
        ...initialState,
      };
    }
    return state;
  })
);

export function reducer(state: ChangeState, action: SelectActionsUnion | StateActions.StateActionsUnion): ChangeState {
  return changeReducer(state, action);
}
